module.exports = __webpack_public_path__ + "static/postIt02-3795dd98ec310532e87c637f68020750.svg";